@if ((pharmacy$ | async); as pharmacy) {
  <p class="caption">
    {{"MEDIFINDER.DETAIL.CONTACT" | translate }}
  </p>
  <p class="header-title">
    {{pharmacy.attributes.name}}
  </p>
  <p class="address">
    {{pharmacy.attributes.address}},
    {{pharmacy.attributes.zip}} {{ pharmacy.attributes.city}}
  </p>
  @if (owner$ | async; as owner) {
    <p class="person">
      {{owner.attributes.field_display_name}}
    </p>
  }
  <div class="pharmacy__link">
    <app-svg-icon
      class="icon"
      [src]="'icons/32/phone.svg'"
      [svgStyle]="{ 'width.px': '32', 'height.px': '32' }"
    ></app-svg-icon>
    <a id="pharmacy-phone" class="button-text"
    href="tel:{{transformPhoneNumber(pharmacy.attributes.phone)}}">{{pharmacy.attributes.phone}}</a>
  </div>
  <div class="pharmacy__link">
    <app-svg-icon
      class="icon"
      [src]="'icons/32/mail.svg'"
      [svgStyle]="{ 'width.px': '32', 'height.px': '32' }"
    ></app-svg-icon>
    <a id="pharmacy-email" class="button-text" href="mailto:{{pharmacy.attributes.email}}?{{('MEDIFINDER.EMAIL.TEXT' | translate:{drug: encodeURIComponent(drugTitle)} )}}">{{pharmacy.attributes.email}}</a>
  </div>
} @else {
  <app-loading></app-loading>
}


